import React from 'react'

function NavBarHamburgerIconMobile() {
  return (
    <svg width="36" height="36" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 6.66667H28M4 16H28M4 25.3333H28" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default NavBarHamburgerIconMobile